<template>
    <v-form v-model="valid">
        <div v-for="(f,i) in form" :key="i" class="question-item" v-bind:class="{ 'disabled-question':disabled[f.id] }">
            
            <div v-if="(currentPage==(i+1) || currentPage=='*') && f.text!='-' " class="mb-10">
                <div class="loader-pages actived" v-if="isLoader">
                    <div class="text-center inner-loader">
                        <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                    </div>
                </div>
                     
                <div v-bind:class="{ 'box-white my-10': f.option_style=='2' }">

                    <div v-if="f.type=='text' || f.type=='video' || f.type=='photo'">
                        
                        <!-- type text -->
                        <div v-if="f.type=='text'">
                            <div class="title_cover" :class="{'pick_a_pict d-flex justify-space-around':data_api.type=='pick_a_pict'}">
                                <div v-if="data_api.type=='pick_a_pict'">
                                    <img @click="$parent.prev()" src="@/assets/images/icon_prev.png" style="max-width: 100%;"/>
                                </div>
                                <h3>{{ f.text }}</h3>
                                <div v-if="data_api.type=='pick_a_pict'">
                                    <img @click="toNextQuestion(f)" src="@/assets/images/icon_next.png" style="max-width: 100%;"/>
                                </div>
                            </div>
                        </div>
                        <!-- type video -->
                        <div v-if="f.type=='video'">
                            <h3>{{ f.text }}</h3>
                            <div class="title_cover">
                                <div class="item_select">
                                    <div class="video_frame">
                                        <iframe width="560" height="315" frameborder="0" allowfullscreen="" :src="f.media" :lazy-src="f.thumbnail || f.media" ></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- type image -->
                        <div v-if="f.type=='photo'">
                            <h3>{{ f.text }}</h3>
                            <div class="item_select">
                                <div class="item_select_image mb-3">
                                    <v-img contain max-width="100%" :src="f.media" :lazy-src="f.thumbnail || f.media">
                                        <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                            >
                                            <v-progress-circular
                                                indeterminate
                                                color="grey lighten-5"
                                            ></v-progress-circular>
                                            </v-row>
                                        </template>
                                    </v-img>
                                </div>
                            </div>
                        </div>

                        <!-- option type written_answer -->
                        <div v-if="f.option_type=='written_answer'">
                            <!-- type short -->
                            <v-text-field v-if="f.written_type=='short'" v-model="answer[f.id]"  :rules="AnswerRules(f)"  :placeholder="f.placeholder" maxlength="500" clearable clear-icon="mdi-close-circle"></v-text-field>
                            <v-textarea v-if="f.written_type=='long'" v-model="answer[f.id]"  :rules="AnswerRules(f)"  :placeholder="f.placeholder" maxlength="500" clearable clear-icon="mdi-close-circle"></v-textarea>
                        </div>
                        <!-- /option type written_answer -->

                        <!-- option type text -->
                        <div v-if="f.option_type && f.option_type=='text'" class="box_white_select mt-5 mb-5">
                            <v-row no-gutters>
                                <v-col cols="12" v-for="(a,j) in f.answers" :key="j" >
                                    <div class="button-list pointer" v-bind:class="{ 
                                        active: (f.is_multiple_choice && answer[f.id] ? (answer[f.id].indexOf(a.id)!==-1) : (answer[f.id]==a.id)),                                        
                                        'active benar': triviaResult[f.id] && triviaResult[f.id].index == j,
                                        salah: triviaResult[f.id] && triviaResult[f.id].index !== j
                                    }"  
                                    @click="chooseAnswer(f, a, f.is_multiple_choice)">
                                    <div class="alphabet">{{ numbToAlphabet(j) }}</div>
                                    <span>{{capitalizeFirstLetter(a.text)}}</span>
                                    <span v-if="percentage && percentage[j]" class="percentage_q">({{percentage[j]}})</span>
                                    </div>
                                </v-col>
                                <v-col cols="12" v-if="f.other_label">
                                    <div v-if="f.is_multiple_choice" class="button-list pointer with_others_field" v-bind:class="{ active: otherMulti[f.id] }">
                                        <div class="button_choice" @click="otherAnswer(f)" style="width: 100%;">
                                            <div class="alphabet">{{ numbToAlphabet(Object.keys(f.answers).length) }}</div>
                                            <span>{{f.other_label}}</span>
                                        </div>
                                        <div class="field_others">
                                            <input type="text" class="input_others" v-model="temp[f.id]" :placeholder="f.other_placeholder || 'Isi disini'" />
                                        </div>
                                    </div>
                                    <div v-else class="button-list pointer with_others_field" @click="otherAnswer(f)" v-bind:class="{ active: ( (answer[f.id] || answer[f.id]=='')  ) && !checkAnsweredInOptions(f, answer[f.id]) }">
                                        <div class="button_choice">
                                            <div class="alphabet">{{ numbToAlphabet(Object.keys(f.answers).length) }}</div>
                                            <span>{{f.other_label}}</span>
                                        </div>
                                        <div class="field_others">
                                            <input type="text" class="input_others" v-model="temp[f.id]" :placeholder="f.other_placeholder || 'Isi disini'" />
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <!-- /option type text -->

                        <!-- option type photo -->
                        <div v-if="f.option_type=='photo'" class="list_images mt-5 mb-5">
                            <v-row no-gutters v-if="data_api.type!='pick_a_pict'">
                            
                            <v-col cols="6" v-for="(a,j) in f.answers" :key="j">
                                <div class="item_select" v-bind:class="{ 
                                    active: (f.is_multiple_choice && answer[f.id] ? (answer[f.id].indexOf(a.id)!==-1) : (answer[f.id]==a.id)),                                    
                                    'active benar': triviaResult[f.id] && triviaResult[f.id].index == j,
                                    salah: triviaResult[f.id] && triviaResult[f.id].index !== j  }">
                                <div class="item_select_image mb-3 pointer" @click="chooseAnswer(f, a, f.is_multiple_choice)">
                                    <img :src="a.media" style="max-width: 100%;"/>
                                </div>
                                <div class="caption_select pointer" @click="chooseAnswer(f, a, f.is_multiple_choice)">
                                    <p>{{a.text}}</p>
                                    <span v-if="percentage && percentage[j]" class="percentage_q">({{percentage[j]}})</span>
                                </div>
                                </div>	
                            </v-col>

                            <v-col cols="12 mt-3" v-if="f.other_label">
                                <div class="button-list pointer with_others_field" @click="otherAnswer(f)" v-bind:class="{ active: ( (answer[f.id] || answer[f.id]=='')  ) && !checkAnsweredInOptions(f, answer[f.id]) }">
                                    <div class="button_choice">
                                        <span>{{f.other_label}}</span>
                                    </div>
                                    <div class="field_others">
                                        <input type="text" class="input_others" v-model="temp[f.id]" :placeholder="f.other_placeholder || 'Isi disini'" />
                                    </div>
                                </div>
                            </v-col>
                            
                            </v-row>
                        </div>
                        <!-- /option type photo -->

                        <!-- option type video -->
                        <div v-if="f.option_type=='video'" class="list_images mt-5 mb-5">
                            <v-row no-gutters>
                            
                            <v-col cols="12" v-for="(a,j) in f.answers" :key="j">
                                    <div class="item_select item_video_select" v-bind:class="{ 
                                        active: (f.is_multiple_choice && answer[f.id] ? (answer[f.id].indexOf(a.id)!==-1) : (answer[f.id]==a.id)),
                                        'active benar': triviaResult[f.id] && triviaResult[f.id].index == j,
                                        salah: triviaResult[f.id] && triviaResult[f.id].index !== j  }">
                                        <div class="video_frame">
                                            <iframe width="560" height="315" frameborder="0" allowfullscreen="" :src="a.media" :lazy-src="a.thumbnail || a.media" ></iframe>
                                        </div>
                                        <div class="caption_select caption_video_select pointer" @click="chooseAnswer(f, a, f.is_multiple_choice)">
                                            <p>{{a.text}}</p>
                                        </div>
                                    </div>
                            </v-col>
                            
                            </v-row>
                        </div>
                        <!-- /option type video -->

                        <!-- option type select_option -->
                        <div v-if="f.option_type=='select_option'" class=" mt-5 mb-5">

                            <v-select v-model="answer[f.id]"
                            placeholder="-- Pilih Jawaban --"
                            :items="f.answers"
                            item-text="text"
                            item-value="id"
                            ></v-select>

                        </div>
                        <!-- /option type select_option -->
                        
                        <!-- option type linear_scale -->
                        <div v-if="f.option_type=='linear_scale'" class=" mt-5 mb-5">
                            
                            <div v-for="(a,i) in f.answers" :key="i">
                            <p>{{a.text}}</p>

                            <v-slider v-model="answer[f.id]" :label="a.min_scale_text" :min="a.min_scale" :max="a.max_scale" thumb-label></v-slider>
                            
                            </div>

                        </div>
                        <!-- /option type linear_scale -->

                    </div>
                    <div v-else-if="f.type=='shuffle'">
                        <shuffle :form="f" />
                    </div>
                    <!-- /type text -->

                
<!-- 
                <v-col cols="12" v-if="isTrivia && triviaResult[f.id]">
                    <v-card class="mx-auto">
                        <v-card-text>
                            <p class="display-1 green--text" v-if="triviaResult[f.id].is_answer">
                                Benar
                            </p>
                            <p class="display-1 red--text" v-else>
                                Salah
                            </p>
                            <p class="text-left">{{triviaResult[f.id].message}}</p>
                        </v-card-text>
                    </v-card>
                </v-col> -->
                <div class="row_stats_ans mt-5" v-if="isTrivia && triviaResult[f.id] && f.type!='shuffle'">
                    <div class="stats_answer benar" v-if="triviaResult[f.id].is_answer">
                        <div class="top_stats">
                            <div class='icon_status'>
                                <img  />
                            </div><!--end.icon_status-->
                            <h3>Benar</h3>
                        </div>
                        <div class="bottom_stats mt-3">
                            <p>{{triviaResult[f.id].message}}</p>
                            <div v-if="triviaResult[f.id].photo" class="mt-10">
                                <v-img contain max-width="100%" :src="triviaResult[f.id].photo" :lazy-src="triviaResult[f.id].photo">
                                    <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                        >
                                        <v-progress-circular
                                            indeterminate
                                            color="grey lighten-5"
                                        ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </div>
                        </div>
                    </div>

                    <div class="stats_answer salah" v-else>
                        <div class="top_stats">
                            <div class='icon_status'>
                                <img  />
                            </div><!--end.icon_status-->
                            <h3>Salah</h3>
                        </div>
                        <div class="bottom_stats mt-3">
                            <p>{{triviaResult[f.id].message}}</p>
                            <div v-if="triviaResult[f.id].photo" class="mt-10">
                                <v-img contain max-width="100%" :src="triviaResult[f.id].photo" :lazy-src="triviaResult[f.id].photo">
                                    <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                        >
                                        <v-progress-circular
                                            indeterminate
                                            color="grey lighten-5"
                                        ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </div>
                        </div>
                    </div>

                </div>
                </div>

                <template v-if="isPrev">
                    <!-- next horizontal type -->
                    <div v-if="(currentPage<=totalPage && f.auto_next!='1') && currentPage!='*' && data_api.type!='pick_a_pict'">
                        <div class="text-center button_motif mt-4 mb-4">

                            <v-row>
                                <v-col cols="6" class="text-left">
                                    <v-btn class="col-12" @click="$parent.prev()" large rounded :loading="isLoading" color="primary" style="min-width: unset!important;" dark :disabled="currentPage<=1 || isLoading"> Prev </v-btn>
                                </v-col>
                                <v-col cols="6" class="text-right">
                                    <v-btn class="col-12" @click="toNextQuestion(f)" large rounded :loading="isLoading" color="primary" style="min-width: unset!important;" dark :disabled="!answer[f.id] || isLoading"> Next </v-btn>
                                </v-col>
                            </v-row>
                            
                        </div>
                    </div>
                    <!-- next horizontal type -->
                </template>
                <template v-else>
                    <!-- next horizontal type -->
                    <div v-if="(currentPage<=totalPage && f.auto_next!='1') && currentPage!='*' && data_api.type!='pick_a_pict'">
                        <div class="text-center button_motif mt-4 mb-4">
                            <v-btn @click="toNextQuestion(f)" large rounded :loading="isLoading" color="primary" dark :disabled="!answer[f.id] || isLoading"> Lanjut </v-btn>
                        </div>
                    </div>
                    <!-- next horizontal type -->
                </template>
            </div>
        </div>

        <!-- next vertical type -->
        <div v-if="currentPage=='*' && (!isTrivia || $store.state.triviaResult ) && !hideNext">
            <div class="text-center button_motif mt-4 mb-4">
                <v-btn @click="$parent.next" large rounded :loading="isLoading" color="primary" dark :disabled="!( valid && (form.length == Object.keys(this.answer).length)) || isLoading || isValidCombine "> Lanjut </v-btn>
            </div>
        </div>
        <!-- next vertical type -->

        <!-- end of question and enabled profiling back position -->
        <div v-if="((currentPage==totalPage) || currentPage=='*') && $store.state.data.get.profiling && $store.state.data.get.using_sso=='1' && $store.state.data.get.using_sso=='back'">
            <span class="help_teks">*Pastikan Anda sudah bergabung ke Liputan6.id menggunakan akun email atau facebook Anda di layar berikutnya</span>
        </div>
        <!-- end of question and enabled profiling back position -->

    </v-form>
</template>

<script>
import Vue from 'vue'
import { mapState } from "vuex"
import { VueReCaptcha } from 'vue-recaptcha-v3'

const Shuffle = () => import(/* webpackChunkName: "shuffle" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackPreload: true */ './Shuffle.vue');

export default {
  name: "Questions",
  props:['form', 'currentPage', 'totalPage', 'isTrivia', 'percentage'],
  computed: mapState(['isLoading', 'isCombine', 'isValidAnswer', 'isValidProfiling', 'isValidCombine']),
  components: { Shuffle },
  data() {
    return {
      modal: false,
      valid: false,
      isLoader: false,
      hideNext: false,
      temp: {},
      disabled: {},
      triviaResult: {},
      data_api: this.$store.state.data.get,
      isPrev: this.$store.state.data.get.display_options ? (JSON.parse(this.$store.state.data.get.display_options)?.display_button_previous == 'show' ? true : false) : false,
      answer: this.$store.state.data.post.answer,
      otherMulti: {}
    }
  },
  methods:{
    AnswerRules(f) {
        var rules = [];

        if( f.validation )
        {
            for( var i in f.validation )
            {
                if( f.validation[i] == 'required' )
                {
                    rules.push(v=>{
                        return !!v || 'wajib diisi'
                    });
                }

                if( f.validation[i] == 'email' )
                {
                    rules.push(v=>{
                        return /.+@.+/.test(v) || 'Format email salah'
                    });
                }

                if( f.validation[i] == 'numeric' )
                {
                    rules.push(v=>{
                        return /^\d+$/.test(v) || 'Format harus angka'
                    });
                }

                if( f.validation[i].substring(0, 9) == 'maxlength' )
                {
                    var n = parseInt(f.validation[i].substring(10, f.validation[i].length-1));

                    rules.push(v=>{
                        return (v ? v.length : 0)<=n || 'maksimal '+n+' karakter'
                    });
                }

                if( f.validation[i] == 'yob' )
                {
                    var year = parseInt(new Date().getFullYear());

                    rules.push(v=>{
                        return /^\d+$/.test(v) && v<=year && (year-v)<80 || 'Format salah'
                    });
                }

                if( f.validation[i] == 'phone' )
                {
                    rules.push(v=>{
                        return /^(((0|\+?62)8\d{8,11})|(\+60\d{8,10})|(\+65\d{8})|(\+673\d{8,10})|(\+886\d{5,8})|(\+852\d{3,11}))$/.test(v) || 'Format telepon salah'
                    });
                }
            }
        }

        return rules;
    },
    toNextQuestion(f)
    {
        //is using logic jump written answer?
        if( this.$store.state.data.get.using_jump_question=='yes' && f.answers )
        {
            if( f.option_type == 'written_answer' )
            {
                this.$parent.jumpPage = f.answers[0].jump_to;
            }
            //question other
            else if( f.other_label && this.answer[f.id] && isNaN(this.answer[f.id]) )
            {
                /*//get last page
                var lastQuestion = f.other_jump_to || this.form.length
                
                this.$parent.jumpPage = lastQuestion;*/

                if( f.other_jump_to )
                {
                    this.$parent.jumpPage = f.other_jump_to
                }
                else
                {   //result
                    this.$parent.$parent.$parent.submit()
                }

            }
        }

        this.$parent.next()
    },
    chooseAnswer(field, answered, isMultiple)
    {
      //return null when this answered was disabled
      if( this.disabled[field.id] ) return false;

      if( !isMultiple )
      {
            this.$set(this.answer, field.id, answered.id);
            this.$forceUpdate();
      }
      else
      {
            var tempAnswer = this.answer[field.id] || []

            var index = tempAnswer.indexOf(answered.id);

            if( (index !== -1) ) 
            {
                tempAnswer.splice(index, 1);
            }
            else
            {
                tempAnswer.push(answered.id)
            }

            if( tempAnswer.length>0 ) 
            {
                this.$set(this.answer, field.id, tempAnswer);
            }
            else
            {
                this.$delete(this.answer, field.id, tempAnswer);
            }
      }

      if( !this.isCombine )
      {
        
        //is using logic jump?
        if(this.$store.state.data.get.using_jump_question=='yes')
        {
            this.$parent.jumpPage = answered.jump_to==0?'result':answered.jump_to;
        }

        //auto next
        if(field.auto_next == '1')
        {
                var th = this
                setTimeout(function(){
                    if( th.currentPage < th.totalPage)
                        th.$parent.next()
                    else
                        th.$parent.$parent.$parent.submit()
                }, 500);
        }
      }
    },
    checkAnsweredInOptions(field, answered)
    {
        for( var a in field.answers )
        {
            if( field.is_multiple_choice && answered && answered.length>0 )
            {
                if( answered.includes(field.answers[a].id) )
                {
                    return true
                }
            }
            else
            {
                if(field.answers[a].id == answered)
                {
                    return true
                }
            }
        }
    },
    checkAnsweredInOptionMultiples(field, answered)
    {
        if( field.is_multiple_choice && answered && this.temp[field.id] )
        {
            if( answered.includes(this.temp[field.id]) )
            {
                return true
            }
        }

        return false
    },
    otherAnswer(field)
    {
        var tempAnswer = (this.answer[field.id] && !this.checkAnsweredInOptions(field, this.answer[field.id])) || (this.temp[field.id] || '')
        
        //init multiple
        if( field.is_multiple_choice )
        {
            if( !this.otherMulti[field.id] )
            {
                this.otherMulti[field.id] = true
            }
            else this.otherMulti[field.id] = false
        }
        if( field.is_multiple_choice && !this.temp[field.id])
        {
            this.$set(this.temp, field.id, '')
        }

        if(tempAnswer!==true) 
        {
            this.$set(this.temp, field.id, tempAnswer)

            if( !field.is_multiple_choice )
                this.$set(this.answer, field.id, tempAnswer)
        }

        this.setOther(field)

        this.$forceUpdate();
    },
    delOther(question)
    {
        //delete
        if( this.answer[question.id] )
        {
            var ids = []
            for( var a in question.answers )
            {
                ids.push(question.answers[a].id)
            }

            for(var d in this.answer[question.id])
            {
                if( !ids.includes(this.answer[question.id][d]) )
                {
                    delete this.answer[question.id][d]
                }
            }
        }
        this.$forceUpdate();
    },
    setOther(question)
    {
        if( !question.is_multiple_choice ) return false

        //delete old
        this.delOther(question);

        var answered = this.answer[question.id] || []
        var tempAnswer = this.temp[question.id] || null
        
        answered = answered.filter(function(j){
            return j ? true : false
        });
        answered = answered.filter(function(value, index, self){
            return self.indexOf(value) === index;
        });

        if(tempAnswer && this.otherMulti[question.id]) answered.push(tempAnswer)

        if(answered.length) 
            this.$set(this.answer, question.id, answered);
        else
        {
            this.$delete(this.answer, question.id);
        }
            
    },
    async recaptcha() {
        if(JSON.parse(this.$store.state.data.get.display_options).use_captcha=='yes'){
            await this.$recaptchaLoaded()
            const token = await this.$recaptcha('submit')
            this.$store.state.data.post.captcha_token = token
        }
    },
  },
  mounted()
  {
    if(JSON.parse(this.$store.state.data.get.display_options).use_captcha=='yes'){
        Vue.use(VueReCaptcha, { siteKey:  this.$store.state.captcha_key })
        this.recaptcha()
    }
    if( this.form )
    {
        for( var f in this.form )
        {
            if( this.form[f].option_type =='written_answer' && this.form[f].text == '-' )
            {
                this.answer[this.form[f].id] = '-';
                this.$parent.$parent.$parent.submit();
            }
        }
    }
    
    if( !this.$store.state.isValidAnswer || this.currentPage=='*' )
    {
        if( this.isCombine )
        {
            this.$store.commit('set_isvalid_answer', ( this.valid && this.isValidProfiling && (this.form.length == Object.keys(this.answer).length) ));

            this.$store.commit('set_is_valid_combine', (this.isValidAnswer && this.isValidProfiling) ? false : true );
        }
        else 
        {
            this.$store.commit('set_isvalid_answer', ( this.valid && (this.form.length == Object.keys(this.answer).length) ));
            this.$store.commit('set_is_valid_combine', (this.isValidAnswer ) ? false : true );
        }
    }

    //valid answer auto next
    if( this.$store.state.isValidAnswer )
    {
        //this.$parent.$parent.$parent.submit();
    }

    //connected survey to personality
    if(this.$route.query && Object.keys(this.$route.query).length !== 0) {
        this.$store.state.isValidAnswer = true;   
        this.answer[this.form[0].id] = this.$route.query.s
        if( this.$store.state.isValidAnswer )
        {
            this.$parent.$parent.$parent.submit();
        }
      
    }
  },
  watch: {
    percentage: function () {
    },
    answer: {
      immediate: true,
      deep: true,
      handler(val) 
      {
        if( this.isCombine )
        {
            this.$store.commit('set_isvalid_answer', ( this.valid && this.isValidProfiling &&  (this.form.length == Object.keys(val).length) ));
            
            this.$store.commit('set_is_valid_combine', (this.isValidAnswer && this.isValidProfiling) ? false : true );
        }
        else 
        {
            this.$store.commit('set_isvalid_answer', ( this.valid && (this.form.length == Object.keys(val).length) ))

            this.$store.commit('set_is_valid_combine', this.isValidAnswer ? false : true );
        }
        
        this.$store.commit('set_post_answer', val);

        this.$session.set('temp_answers',val)

        for( var i in this.form )
        {
            if(this.form[i].other_label && !this.checkAnsweredInOptions(this.form[i], val[this.form[i].id]))
            {
                //this.temp[this.form[i].id] = val[this.form[i].id]
            }
            else
            {
                if( this.form[i].text && (this.checkAnsweredInOptions(this.form[i], val[this.form[i].id]) || val[this.form[i].id]) )
                {
                    var addAns = []

                    var opts = {};
                    for( var op in this.form[i].answers )
                    {
                        opts[this.form[i].answers[op].id] = this.form[i].answers[op].text || null
                    }

                    if( this.form[i].is_multiple_choice )
                    {
                        if( val[this.form[i].id] )
                        {
                            for( var an in val[this.form[i].id] )
                            {
                                addAns.push(opts[val[this.form[i].id][an]] || val[this.form[i].id][an] )
                            }
                        }
                    }
                    else
                    {
                        addAns.push(opts[val[this.form[i].id]] || val[this.form[i].id] )
                    }

                    if(addAns) this.$store.state.data.post.additional[this.form[i].text] = addAns.join(', ');
                }
            }

            //set disabled for Trivia Quiz
            if( this.isTrivia )
            {
                this.disabled[this.form[i].id] = val[this.form[i].id] ? true : false

                if(!val[this.form[i].id]) this.$delete(this.triviaResult, this.form[i].id);

                if( !this.triviaResult[this.form[i].id] && val[this.form[i].id])
                {
                    var triviaAnswer = {};
                    triviaAnswer[this.form[i].id] = val[this.form[i].id];

                    //submit trivia vertical  
                    if( this.valid && (this.form.length == Object.keys(val).length) ) 
                    {
                        this.$store.commit('finish_trivia');
                    }

                    this.isLoader = true;
                        
                    this.$store.dispatch('api_post_ic_trivia', [triviaAnswer, res=>{

                        if( res.q && res.q[0] )
                        {
                            res.data.id = val[res.q[0]]
                            this.$set(this.triviaResult, res.q[0], res.data);

                            this.isLoader = false;

                            if(res.data.result)
                            {
                                this.$store.state.triviaResult = res.data.result

                                //submit score
                                if( res.data.true_answers )
                                {
                                    this.$store.state.data.post.score = res.data.true_answers
                                    this.$store.state.data.post.interactive_result_id = res.data.result.id
                                    //auto next
                                    //this.$parent.$parent.$parent.submit();
                                }
                            }
                        }

                        document.dispatchEvent(new Event("trivia:submitted"));

                    }]);
                }
            }
        }
      }
    },
    temp: {
      immediate: true,
      deep: true,
      handler(val) 
      {
        for(var i in val)
        {
            for( var f in this.form )
            {
                if( this.form[f].id == i )
                {
                    if(this.otherMulti[i] && this.form[f].is_multiple_choice )
                    {
                        this.setOther(this.form[f]);
                    }
                    else
                    {
                        this.$set(this.answer, i, val[i])

                        if(val[i]) this.$store.state.data.post.additional[this.form[f].text] = val[i];
                    }
                }
            }
        }
      }
    }
  }
}
</script>